import type { FailureCause } from "./user-view.ts"

export type FailureRecovery = {
  readonly action: { readonly href: string; readonly kind: "link"; readonly label: string } | { readonly kind: "command" }
  readonly description: string
  readonly heading: string
}

const recoveries: Readonly<Record<FailureCause, FailureRecovery>> = {
  DELETION_BLOCKED: {
    action: { href: "/balance/history", kind: "link", label: "진행 상태 확인" },
    description: "진행 중인 거래가 있어 지금은 탈퇴할 수 없습니다. 거래가 끝난 뒤 다시 요청해 주세요.",
    heading: "탈퇴 요청을 진행할 수 없습니다",
  },
  EXPIRED_ENTRY: {
    action: { href: "/transfer/start", kind: "link", label: "처음부터 다시 시작" },
    description: "제휴사에서 전달된 연결 시간이 끝났습니다. 새 전환 요청으로 다시 시작해 주세요.",
    heading: "연결 시간이 만료되었습니다",
  },
  INSUFFICIENT_BALANCE: {
    action: { href: "/balance", kind: "link", label: "사용 가능 잔액 확인" },
    description: "상품 교환에 필요한 사용 가능 잔액이 부족합니다. 보류 금액과 소멸 예정 금액을 함께 확인해 주세요.",
    heading: "사용 가능한 잔액이 부족합니다",
  },
  MMS_DELIVERY_FAILED: {
    action: { kind: "command" },
    description: "상품권은 발급되었지만 MMS 발송을 완료하지 못했습니다. 같은 상품권을 안전하게 다시 발송할 수 있습니다.",
    heading: "MMS 발송을 완료하지 못했습니다",
  },
  QUOTE_EXPIRED: {
    action: { href: "/transfer/start", kind: "link", label: "새 전환 시작" },
    description: "전환 견적의 유효시간이 지나 확정할 수 없습니다. 현재 기준으로 새 견적을 확인해 주세요.",
    heading: "전환 견적이 만료되었습니다",
  },
}

export const failureRecovery = (cause: FailureCause): FailureRecovery => recoveries[cause]
